import React, { useState } from "react";
import {
  MDBSideNavCat,
  MDBSideNavNav,
  MDBSideNav,
  MDBSideNavLink,
} from "mdbreact";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import { Link } from "react-router-dom";
import { Button } from "react-rainbow-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSignOutAlt } from "@fortawesome/free-solid-svg-icons";
import { logout } from "../../redux/actions/authActions";

const Navigation = () => {
  const [toggle, settoggle] = useState(false);
  const { user } = useSelector((state: RootState) => state.auth);
  let selectedItem: string = "item-1";
  const dispatch = useDispatch();

  return (
    <header style={{ width: "9vw" }}>
      <div className="mdb-skin">
        <MDBSideNav
          slim
          fixed
          triggerOpening={toggle}
          breakWidth={0}
          openNav={true}
          responsive={true}
          className="background-color-blue"
        >
          <li>
            <div className="logo-wrapper sn-ad-avatar-wrapper">
              <Link to="/">
                <img
                  className="rounded-circle"
                  alt="Image Presentateur"
                  src={`https://covers.radioemotion.be/images/equipe/${user?.username}.jpg`}
                ></img>
                <span>{user?.username}</span>
              </Link>
            </div>
          </li>
          <MDBSideNavNav toggleNavLabel="Reduire la navigation">
            {user?.adminRole?.info.create === 1 ||
            user?.adminRole?.info.update === 1 ? (
              <MDBSideNavCat name="Info" id="Info" icon="newspaper">
                {user?.adminRole?.info.create === 1 ? (
                  <MDBSideNavLink shortcut="CR" to="/actualite/create">
                    Créer
                  </MDBSideNavLink>
                ) : (
                  <></>
                )}
                {user?.adminRole?.info.update === 1 ? (
                  <MDBSideNavLink to="/actualite/list">Modifier</MDBSideNavLink>
                ) : (
                  <></>
                )}
              </MDBSideNavCat>
            ) : (
              <></>
            )}
            {user?.adminRole?.agenda.create === 1 ||
            user?.adminRole?.agenda.update === 1 ? (
              <MDBSideNavCat name="Agenda" id="Agenda" icon="calendar-alt">
                {user?.adminRole?.agenda.create === 1 ? (
                  <MDBSideNavLink shortcut="CR" to="/agenda/create">
                    Créer
                  </MDBSideNavLink>
                ) : (
                  <></>
                )}
                {user?.adminRole?.agenda.update === 1 ? (
                  <MDBSideNavLink to="/agenda/list">Modifier</MDBSideNavLink>
                ) : (
                  <></>
                )}
              </MDBSideNavCat>
            ) : (
              <></>
            )}

            {user?.adminRole?.music.create === 1 ||
            user?.adminRole?.music.update === 1 ? (
              <MDBSideNavCat name="Discothèque" id="Music" icon="music">
                {user?.adminRole?.music.create === 1 ? (
                  <MDBSideNavLink shortcut="CR" to="/music/top30">
                    Top 30
                  </MDBSideNavLink>
                ) : (
                  <></>
                )}
                {user?.adminRole?.music.update === 1 ? (
                  <MDBSideNavLink to="/music/list">
                    Toute la discothèque
                  </MDBSideNavLink>
                ) : (
                  <></>
                )}
              </MDBSideNavCat>
            ) : (
              <></>
            )}

            {user?.adminRole?.emission.create === 1 ||
            user?.adminRole?.emission.update === 1 ? (
              <MDBSideNavCat name="Emissions" id="Emissions" icon="podcast">
                {/* {user?.adminRole?.emission.create === 1 ? <MDBSideNavLink shortcut="CR">Mes emissions</MDBSideNavLink> :  <></>} */}
                {user?.adminRole?.emission.update === 1 ? (
                  <MDBSideNavLink to="/emission/monplanning">
                    Mes emissions
                  </MDBSideNavLink>
                ) : (
                  <></>
                )}
                {user?.adminRole?.emission_full_access.crud === 1 ? (
                  <MDBSideNavLink to="/emission/listallemission">
                    Toutes les emissions
                  </MDBSideNavLink>
                ) : (
                  <></>
                )}
              </MDBSideNavCat>
            ) : (
              <></>
            )}

            {user?.adminRole?.podcast.create === 1 ||
            user?.adminRole?.podcast.update === 1 ? (
              <MDBSideNavCat name="Podcast" id="Music" icon="music">
                {user?.adminRole?.podcast.create === 1 ? (
                  <MDBSideNavLink shortcut="PD" to="/podcast/createpodcast">
                    Créer
                  </MDBSideNavLink>
                ) : (
                  <></>
                )}
                {user?.adminRole?.podcast.crud === 1 ? (
                  <MDBSideNavLink to="/podcast/list">Modifier</MDBSideNavLink>
                ) : (
                  <></>
                )}
              </MDBSideNavCat>
            ) : (
              <></>
            )}
          </MDBSideNavNav>
          <div className="w-100 text-left">
            <Button
              variant="base"
              className="text-white ml-2"
              style={{ fontSize: ".8rem" }}
              onClick={() => dispatch(logout())}
            >
              <FontAwesomeIcon className="mr-4" icon={faSignOutAlt} />
              Déconnection
            </Button>
          </div>
        </MDBSideNav>
      </div>
      {/* <VerticalNavigation
        id="vertical-navigation-11"
        selectedItem={selectedItem}
        // onSelect={this.handleOnSelect}
        className="background-color-blue"
        style={{ height: '100vh', backgroundColor: '#f9fafc' }}
      >
        <div className="d-flex pl-3 align-items-center pt-3 mb-3">
          <Avatar
            src={`https://www.radioemotion.be/images/equipe/${user?.username}.jpg`}
            assistiveText={`${user?.username}`}
            title={`${user?.username}`}
            size="large"
          />
          <span className="pl-2">{user?.username}</span>

        </div>
        <VerticalSectionOverflow label="Info" description="" className="border-top border-white">
          <VerticalItem
            name="item-1"
            label="Créer"
            icon={<FontAwesomeIcon icon={faPlus} />}
          />
          <VerticalItem
            name="item-4"
            label="Modifier"
            style={{ color: 'white' }}
            icon={<FontAwesomeIcon icon={faEdit} />}
          />
        </VerticalSectionOverflow>
        <VerticalSectionOverflow label="Agenda" description="">
          <VerticalItem name="item-2" label="Créer" icon={<FontAwesomeIcon icon={faPlus} />} />
          <VerticalItem name="item-18" label="Modifier" icon={<FontAwesomeIcon icon={faEdit} />} />
        </VerticalSectionOverflow>
        <VerticalSectionOverflow
          label="Discothèque"
          description=""
        >
          <VerticalItem name="item-5" label="Créer" icon={<FontAwesomeIcon icon={faPlus} />} />
          <VerticalItem name="item-6" label="Toute la discothèque" icon={<FontAwesomeIcon icon={faEdit} />} />
        </VerticalSectionOverflow>
        <VerticalSectionOverflow
          label="Emissions"
          description=""
        >
          <VerticalItem name="item-5" label="Mes emissions" icon={<FontAwesomeIcon icon={faEdit} />} />
          <VerticalItem name="item-6" label="Toute les emissions" icon={<FontAwesomeIcon icon={faEdit} />} />
        </VerticalSectionOverflow>
        <VerticalSection>
          <VerticalItem name="item-5" label="Déconnecton" icon={<FontAwesomeIcon icon={faSignOutAlt} />} />
        </VerticalSection>
      </VerticalNavigation> */}
    </header>
  );
};

export default Navigation;
